import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
} from "reactstrap";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { addIndividual } from "../../../slices/individuals/thunk";
const AddIndividualsModal = ({ open, setOpen, onCreate }) => {
  const dispatch = useDispatch();
  const toggleModalAddUser = () => {
    setOpen(!open);
  };

  const [loading, setLoading] = useState(false);

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      const response = await dispatch(
        addIndividual({
          //   id: id ? id : currentUser.id,
          data: values,
        })
      ).unwrap();
      if (response.error) {
        Swal.fire({
          title: "Oops!",
          text: `${response.error}`,
          icon: "error",
          confirmButtonText: "Ok",
        });
        setOpen(true);
        return;
      } else {
        // Success
        Swal.fire({
          title: "Success!",
          text: `Individual ${values.email} added successfully!`,
          icon: "success",
          confirmButtonText: "Ok",
        });

        if (onCreate) {
          onCreate();
        }

        setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  return (
    <>
      <Modal isOpen={open} toggle={toggleModalAddUser} fade={false}>
        <ModalHeader toggle={toggleModalAddUser}>Add Individual</ModalHeader>
        <ModalBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ isSubmitting, values }) => {
              const isFieldsCompleted =
                values.firstName && values.lastName && values.email;
              return (
                <Form>
                  <div className="mb-3">
                    <label htmlFor="firstName" className="form-label">
                      First Name
                    </label>
                    <Field
                      type="text"
                      name="firstName"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">
                      Last Name
                    </label>
                    <Field
                      type="text"
                      name="lastName"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <Field type="email" name="email" className="form-control" />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100"
                    disabled={isSubmitting || !isFieldsCompleted}
                  >
                    {isSubmitting ? (
                      <div className="spinner-border spinner-border-sm mr-3"></div>
                    ) : (
                      "Add Individual"
                    )}
                  </Button>{" "}
                </Form>
              );
            }}
          </Formik>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddIndividualsModal;
